var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 14,
    viewBox: "0 0 8 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.469668 0.469668C0.762558 0.176777 1.2374 0.176777 1.5303 0.469668L7.5303 6.4697C7.8232 6.7626 7.8232 7.2374 7.5303 7.5303L1.5303 13.5303C1.2374 13.8232 0.762558 13.8232 0.469668 13.5303C0.176777 13.2374 0.176777 12.7626 0.469668 12.4697L5.9393 7L0.469668 1.53033C0.176777 1.23744 0.176777 0.762558 0.469668 0.469668Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/rightArrow.0325a6a05f9ae76d0926ba93f0ca0e59.svg";
export { ForwardRef as ReactComponent };